"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _Carousel = _interopRequireDefault(require("./Carousel"));

exports["default"] = _Carousel["default"];